import { Fragment } from "react";
import useFetch from "../../../../hook/useFetch";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notification-slice";

export default function ResetLinks(props){

    const {user}=props

    const {post}=useFetch()

    let dispatch=useDispatch()


    return <Fragment>
           <div className="mt-3"  >
            <p>send account aktivate link to user mail</p>
            <button className="btn btn-secondary" onClick={()=>{
                     
                     post(`/admin/confirmrequest?email=${user.email}&redirect=${process.env.REACT_APP_BASE_URL}`, null, null, (data) => {
                     
                      dispatch(notificationActions.setNotification({
                          message:data,
                          status:true
                      }))

                  })
                     
                  }} >AcountActivate</button>
        </div>
        <div className="mt-3"  >
            <p>send reset password link to user mail</p>
            <button className="btn btn-secondary" onClick={()=>{
                     
                       post(`/admin/reset-request?email=${user.email}&redirect=${process.env.REACT_APP_BASE_URL}`, null, null, (data) => {
                       
                        dispatch(notificationActions.setNotification({
                            message:data,
                            status:true
                        }))

                    })
                       
                    }} >RestPassword</button>
        </div>
    </Fragment>
}